exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-button--text[data-v-441a2f1e] {\r\n    padding: 0 !important;\r\n    width: auto !important;\r\n    margin-left: 5px !important;\n}\n.el-button--text span[data-v-441a2f1e]{\r\n  margin-left: 0px !important;\n}\r\n", ""]);

// exports
